export default {
  closedSessions: state => state.closedSessions,
  getSectionbyId: state => id => {
    return state.closedSessions.items
      ? state.closedSessions.items.find(s => s.id === id)
      : null
  }
}
